import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Dropdown, Radio, Row, Space,DatePicker, message, Modal } from 'antd';

import { BASE_URL,AddStaff, UploadFile, FetchDepartment, FetchDesignation, FetchShifts, FetchLocation, STAFF_ROLE, CompanyDropdownList, UpdateBo, CHECKAUTH_ENDPOINT } from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { CameraOutlined } from "@ant-design/icons";
import moment from "moment";
import { getBase64DataFromBinary } from "../../utils";
import Input from "../../common/Input";
import AttachIcon from "../../assets/icons/attach.svg";
import Select from "../../common/Select";
import Button from "../../common/Button";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserInformation } from '../../store/slices/signUpSlice';
import { setDesig } from '../../store/slices/designationSlice';
import { setDept } from '../../store/slices/departmentSlice';
import { setLoc } from '../../store/slices/locationSlice';
import { setShft } from '../../store/slices/shiftSlice';
import Spinner from "../../common/Spinner";
import ModalConfirm from "../../common/modalConfirm";
const BoForm = ({ open, onCancel, initialValues }) => {
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [companyLogo, setCompanyLogo] = useState();
  const [companyName, setCompanyName] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [companyType, setCompanyType] = useState();
  const [gender, setGender] = useState();
  const [aadharNumber, setAadharNumber] = useState();
  const [aadharFile, setAadharFile] = useState();
  const [organizationAddress, setOrganizationAddress] = useState();
  const [companyTypeOptions, setCompanyTypeOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([
    { value: 'male', label: 'male' },
    { value: 'female', label: 'female' },
    { value: 'other', label: 'other' },
    
  ]);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const [modalReloginVisible, setModalReloginVisible] = useState(false);

  const relogin = () => {
    setModalReloginVisible(true);
  };
  const handleReloginOk = (params) => {
    navigate('/')
    localStorage.clear()
    sessionStorage.clear();
    dispatch(setUserInformation(''));
    dispatch(setDesig(''));
    dispatch(setDept(''));
    dispatch(setLoc(''));
    dispatch(setShft(''));
    onCancel()
    setModalReloginVisible(false);
  };
  const handleReloginCancel = () => {
    setModalReloginVisible(false);
  };
  const handleCompanyName = useCallback((value) => {
    // setCompanyName(() => value.target.value);
    setCompanyName(value.target.value);
    
  }, []);
  useEffect(() => {
    console.log('effect')
    setCompanyLogo(userInfo?.logo);
    setCompanyName(userInfo?.companyName);
    setFirstName(userInfo?.firstName);
    setLastName(userInfo?.lastName);
    setEmail(userInfo?.email);
   setPhoneNumber(userInfo?.phoneNumber);
    setCompanyType(userInfo?.companyType);
    setGender(userInfo?.gender);
    setAadharNumber(userInfo?.aadharNumber);
    setAadharFile(userInfo?.aadharFile);
    setOrganizationAddress(userInfo?.organizationAddress);
  },[open])

  //update first name
  const handleFirstName = useCallback((value) => {
    // setFirstName(() => value.target.value);
    setFirstName(value.target.value);
    
  }, []);
  
  //update last name
  const handleLastName = useCallback((value) => {
    // setLastName(() => value.target.value);
    setLastName(value.target.value);
  }, []);
  
  //update email
  const handleEmail = useCallback((value) => {
    const enteredEmail = value.target.value;
    setEmail(() => enteredEmail);
  
    // Email validation using a regular expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(enteredEmail);
  
    // You can handle the validation result as per your requirements
    if (!isValidEmail) {
      // Show an error message or disable the "Continue" button, etc.
      console.log('Invalid email address');
    }
  }, []);
  
  //update phone number
  const handlePhoneNumber = useCallback((value) => {
    // setPhoneNumber(() => value.target.value);
    setPhoneNumber(value.target.value);
    
  }, []);

  //update type of employee
  const handleCompanyType = useCallback((value) => {
    setCompanyType(() => value);
  }, []);
  
  //update gender
  const handleGender = useCallback((value) => {
    console.log('value',value)
    setGender(() => value);
  }, []);
  
  //update aadhar number
  const handleAadharNumber = useCallback((value) => {
    if(value.target.value.length < 13)setAadharNumber(() => value.target.value);
  }, []);
  
  //update organization address
  const handleOrganizationAddress = useCallback((value) => {
    setOrganizationAddress(() => value.target.value);
  }, []);
  
  //update password
 
  
  //upload aadhar
  const handleAadhar = (e) => {
    const file = e.target.files[0];
    if (file) {
        // Check if the file size is less than or equal to 2 MB
        const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
        if (file.size <= maxSizeInBytes) {
            // Check if the file type is either a PDF or an image
            if (
                file.type.startsWith("application/pdf") ||
                file.type.startsWith("image/")
            ) {
                setAadharFile(file);
            } else {
                toast.error('Select PDF or image only.', {
                  position: toast.POSITION.TOP_RIGHT,
              }); 
            }
        } else {
          toast.error('File size should be less than or equal to 2 MB.', {
            position: toast.POSITION.TOP_RIGHT,
        });        
      }
    }
};

  //handle upload logo
  const handleUploadLogo = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file type is an image
      if (file.type.startsWith("image/")) {
        // Check if the file size is less than or equal to 2 MB
        const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
        if (file.size <= maxSizeInBytes) {
          // Get the file extension
          const extension = file.name.split('.').pop().toLowerCase();
          
          // Allowed file extensions
          const allowedExtensions = ['png', 'jpg', 'jpeg'];
          console.log('working1')
          
          // Check if the file extension is allowed
          if (allowedExtensions.includes(extension)) {
                  console.log('working')
                    setCompanyLogo(file);
                } else {
                    toast.error('Only PNG, JPG, and JPEG formats are allowed for the logo.', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {
                toast.error('File size should be less than or equal to 2 MB.', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } else {
            toast.error('Select image only.', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    }
};

  useEffect(() => {
    getCompanyDropdownList()

	}, []);

  const getCompanyDropdownList = async () =>{
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${CompanyDropdownList}`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          masterType: "companyType"
        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        const companyTypeOptions = data?.data[0]?.masterNames?.map((item) => ({
          value: item.key,
          label: item.value,
        }));
        setCompanyTypeOptions(companyTypeOptions)
        console.log('CompanyData',data)
        
      } else {
        const data = await response.json();
        console.log('CompanyDataerr',data)
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
        
      }
    };
    fetchData();
  }

  const getBoData = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${CHECKAUTH_ENDPOINT}`, {
        method: "GET",
         headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token }`,
                  
                },
        body: JSON.stringify(),
      });
      
      if (response.ok) {
        const data = await response.json();
      
        dispatch(setUserInformation(data?.data));

       
      } else {
        const data = await response.json();
        console.log('indexerr',data)
             
      }
    };
     fetchData();
  }
  const handleUpdate = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;
  if (!emailRegex.test(email)) {
    // Show an error message using toast
    toast.error('Invalid Email Address', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the email is invalid
  }
  if (!phoneRegex.test(phoneNumber)) {
    // Show an error message for an invalid phone number
    toast.error('Invalid Phone Number. Please enter a 10-digit number.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
 
  if (!companyName) {
    toast.error('Company Name is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  if (!firstName) {
    toast.error('First Name is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  const containsNumbers = /\d/.test(firstName);
  const LastNamecontainsNumbers = /\d/.test(lastName);

if (containsNumbers) {
    toast.error('First Name cannot contain numbers.', {
        position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the first name contains numbers
}
  if (!lastName) {
    toast.error('Last Name is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  if (LastNamecontainsNumbers) {
    toast.error('Last Name cannot contain numbers.', {
        position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the first name contains numbers
}
  if (!companyType) {
    toast.error('Company Type is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  if (!gender) {
    toast.error('Gender is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  if (!aadharNumber) {
    toast.error('Aadhar Number is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  if (!aadharFile) {
    toast.error('Aadhar File is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
  if (!organizationAddress) {
    toast.error('Organization Address is required.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    return; // Stop the signup process if the phone number is invalid
  }
    // console.log('payload',getPayload())
    // const response = await signUp(getPayload());
    setIsLoadingSpinner(true);
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      
      const formData = new FormData();
      formData.append("boId", userInfo?._id);   
      
    userInfo?.logo !== companyLogo &&  formData.append("logo", companyLogo);   
    userInfo?.companyName !== companyName &&  formData.append("companyName", companyName);
    userInfo?.firstName !== firstName && formData.append("firstName", firstName);
    userInfo?.lastName !== lastName && formData.append("lastName", lastName);
    userInfo?.email !== email && formData.append("email", email);
    userInfo?.phoneNumber !== phoneNumber && formData.append("phoneNumber", phoneNumber);
    userInfo?.companyType !== companyType && formData.append("companyType", companyType);
    userInfo?.gender !== gender && formData.append("gender", gender);
    userInfo?.aadharNumber !== aadharNumber && formData.append("aadharNumber", aadharNumber);
    userInfo?.aadharFile !== aadharFile && formData.append("aadharFile", aadharFile);
    userInfo?.organizationAddress !== organizationAddress && formData.append("organizationAddress", organizationAddress);
    console.log('formData',formData)
    const response = await fetch(`${BASE_URL}/${UpdateBo}`, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: formData,
    });
    
    if (response.ok) {
      const data = await response.json();
      console.log('data',data)
      if(userInfo?.phoneNumber !== phoneNumber){
        
        // navigate('/')
        // localStorage.clear()
        // sessionStorage.clear();
        // dispatch(setUserInformation(''));
        // dispatch(setDesig(''));
        // dispatch(setDept(''));
        // dispatch(setLoc(''));
        // dispatch(setShft(''));
        relogin()
      }else{
        await getBoData()

        await onCancel()
      }
      setIsLoadingSpinner(false);
    } else {
      const data = await response.json();
      setIsLoadingSpinner(false);
      toast.error(data.errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
      });
      console.log('errdata',data)
         
     };
     
    
  };
  fetchData();
  
};
  return (
    <Modal
      title="Update BO"
      open={open}
      okButtonProps={{ style: { background: "grey" } }}
      onCancel={onCancel}
      footer={null}
    >
      {isLoadingSpinner &&    <Spinner/>  }
     <ToastContainer position="top-right" autoClose={2000} />

     <div className="h-full">
        <Row className="h-full">
         
          <Col lg={24} className="bg-[#F5FBFE] h-full">
            <div className="flex flex-col h-full items-center login-part-back py-11 overflow-auto">
              <div className="justify-end gap-y-1.5 w-[440px]">
               
                <div className="text-center mt-1 mb-8">
                  <label className="w-[58px] h-[58px] bg-[#d2dfe7] flex items-center justify-center mx-auto rounded-full cursor-pointer">
                    {!companyLogo && (
                      <CameraOutlined className="text-[#4B8AEB]" />
                    )}
                    <input
                      type="file"
                      className="hidden"
                      accept="image/*"
                      onChange={handleUploadLogo}
                    />
                    {userInfo && companyLogo && (
                      <img
                        src={companyLogo == userInfo.logo ? `${companyLogo}?${new Date().getTime()}` : getBase64DataFromBinary(companyLogo)}
                        alt="company_logo"
                        className="overflow-hidden rounded-full w-full h-full object-cover"
                      />
                    )}
                  </label>
                  <span className="font-sbold text-sm">Logo</span>
                </div>
                <Input
                  type="text"
                  placeholder="Company Name"
                  value={companyName}
                  onChange={handleCompanyName}
                />
                <div className="grid grid-flow-col gap-2">
                  <Input
                    type="text"
                    placeholder="Your First Name"
                    value={firstName}
                    onChange={handleFirstName}
                  />
                  <Input
                    type="text"
                    placeholder="Your Last Name"
                    value={lastName}
                    onChange={handleLastName}
                  />
                </div>
                <Select
                 options={companyTypeOptions}
                 value={companyType}
                  onChange={handleCompanyType} />
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={handleEmail}
                />
                <Input
                  type="tel"
                  placeholder="Phone Number"
                  value={phoneNumber}
                  onChange={handlePhoneNumber}
                  maxLength={10}
                />
                <Select
                  label="Sex"
                  options={genderOptions}
                  value={gender}
                  onChange={handleGender}
                />
                <div className="relative mb-0">
                  <Input
                    type="number"
                    placeholder="Aadhar No"
                    value={aadharNumber}
                    onChange={handleAadharNumber}
                  />
                  <label className="absolute right-3.5 top-4 flex items-center cursor-pointer">
                    <img src={AttachIcon} />
                    <input
                      type="file"
                      className="hidden"
                      onChange={handleAadhar}
                    />
                  </label>
                </div>
                <Input
                  type="text"
                  placeholder="Organization Address"
                  value={organizationAddress}
                  onChange={handleOrganizationAddress}
                />
                
                <Button label="Update" onSubmit={handleUpdate} />
                
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <ModalConfirm
        visible={modalReloginVisible}
        onOk={handleReloginOk}
        onCancel={handleReloginCancel}
        title="Re-login"
        content="A re-login is required after updating your phone number."
      />
    </Modal>
  );
};

export default BoForm;
